import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
`

export const Grid = styled.div`
  display: grid;
  gap: var(--space-500);
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(
      auto-fit,
      minmax(max(450px, calc((100% - 2 * var(--space-500)) / 3)), 1fr)
    );
  }
`
